import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#f5f5f5',
  },
  sidebar: {
    backgroundColor: '#fff',
    borderRightWidth: 1,
    borderRightColor: '#ddd',
    paddingTop: 20,
    position: 'relative',
  },
  toggleButton: {
    padding: 12,
    alignItems: 'center',
    position: 'absolute',
    top: 20,
    left: 43,
  },
  menuItemContainer: {
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  isSelected: {
    backgroundColor: theme.colors.newUI.therapist.bgBlue10,
    borderLeftWidth: 8,
    borderColor: theme.colors.newUI.therapist.green70,
    paddingLeft: 0,
  },
  menuLabel: {
    fontSize: 16,
    color: '#333',
  },
  mainContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentText: {
    fontSize: 18,
    color: '#333',
  },
  subMenuContainer: {
    position: 'absolute',
    left: '100%',
    top: 0,
    backgroundColor: theme.colors.white,
    paddingVertical: 10,
    paddingHorizontal: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 9999,
    elevation: 10,
  },
  subMenuItem: {
    paddingVertical: 8,
    fontSize: 16,
    color: theme.colors.black,
  },
  subMenuOverlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 9999,
    elevation: 20,
  },
  subMenuWrapper: {
    position: 'absolute',
    bottom: 50,
    backgroundColor: theme.colors.white,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 10,
    width: 250,
  },
  expandedMenuItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  urlText: {
    paddingTop: theme.spacings.md,
    fontWeight: 'bold',
  },
});
